<template>
    <div class="grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5 pb-3">
        <h6 class="px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray">Dati aziendali</h6>

        <div class="grid grid-cols-2 gap-4">
            <div class="flex flex-col pb-3">
                <Field field_name="Azienda estera"
                       :errors="getErrors('estera')">
                    <Select :modelValue="estera"
                            @update:modelValue="$emit('update:estera', $event)"
                            :disabled="disable_dati_azienda"
                    ></Select>
                </Field>
            </div>
            <div class="flex flex-col pb-3 grow">
                <Field field_name="Tipo" :errors="getErrors('tipo')">
                    <VueMultiselect v-model="tipo_model" :options="tipo_options"
                                    :multiple="false"
                                    :disabled="disable_dati_azienda"
                                    :allowEmpty="false"
                                    :close-on-select="true" :clear-on-select="false"
                                    selectLabel=""
                                    deselectLabel=""
                                    selectedLabel=""
                                    placeholder="Tipo cliente"
                                    class="next-vue-multiselect-single"
                                    track-by="id" label="text">
                        <template v-slot:noResult>Nessun elemento trovato.</template>
                    </VueMultiselect>
                </Field>
            </div>
        </div>

        <div class="flex flex-col mb-3">
            <Field field_name="Partita IVA" :required="!estera && tipo == 0 && !disabled"
                   :errors="getErrors('partita_iva')">
                <VueMultiselect
                    v-model="aziendaAutocomplete.selection"
                    :options="aziendaAutocomplete.options"
                    :disabled="disable_autocomplete_azienda"
                    :taggable="true"
                    :clear-on-select="false"
                    :preserveSearch="true"
                    @tag="(value)=>aziendaAutocomplete.add({id:-1, partita_iva:value})"
                    placeholder="Partita IVA"
                    class="next-vue-multiselect-single"
                    track-by="id"
                    label="partita_iva"
                    selectLabel=""
                    deselectLabel=""
                    selectedLabel=""
                    :internal-search="false"
                    @search-change="anagraficheAutocompleteSarch"
                >
                    <template v-slot:option="{option}">
                        <div class="flex flex-col text-sm">
                            <template v-if="option.isTag">
                                        <span>Aggiungi partita IVA: <span
                                            class="font-bold">{{ option.label }}</span></span>
                            </template>
                            <template v-else>
                                <div class="flex items-center justify-between">
                                    <div class="flex flex-col">
                                                <span>Azienda: <span class="font-bold">{{
                                                        option.partita_iva
                                                    }}</span></span>
                                        <span>Ragione sociale: <span
                                            class="font-bold">{{ option.ragione_sociale }}</span></span>
                                        <span>CF: <span class="font-bold">{{
                                                option.codice_fiscale
                                            }}</span></span>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </template>
                </VueMultiselect>
            </Field>
        </div>
        <div class="flex flex-col mb-3">
            <Field field_name="Codice fiscale" :required="!estera"
                   :model-value="codice_fiscale"
                   :input-attrs="{disabled:disable_dati_azienda}"
                   @update:model-value="$emit('update:codice_fiscale', $event)"
                   :errors="getErrors('codice_fiscale')">
            </Field>
        </div>

        <div class="flex flex-col mb-3">
            <Field field_name="Ragione sociale"
                   :required="true"
                   :model-value="ragione_sociale"
                   :input-attrs="{disabled:disable_dati_azienda}"
                   @update:model-value="$emit('update:ragione_sociale', $event)"
                   :errors="getErrors('ragione_sociale')"></Field>
        </div>

        <div class="flex flex-col mb-3 col-span-2">
            <MapViewer
                hide_map
                :placeId="place_id"
                :lat="lat"
                :lng="lng"
                :readonly="disable_dati_azienda"
                @update:placeId="$emit('update:place_id', $event)"
                @update:lat="$emit('update:lat', $event)"
                @update:lng="$emit('update:lng', $event)"
                @addressInformationChange="onAddressInformationChange">

                <template v-slot:actual="{actual}">
                    <p>Selezione attuale: <b>{{
                            actual?.formatted_address || '----'
                        }}</b></p>
                </template>
            </MapViewer>
        </div>

        <div class="grid grid-cols-8 gap-3 mb-3">
            <div class="col-span-6 flex flex-col">
                <Field field_name="Sede legale via"
                       :required="!sede_legale_via"
                       :model-value="sede_legale_via"
                       :input-attrs="{disabled:disable_dati_azienda}"
                       @update:modelValue="$emit('update:sede_legale_via', $event)"
                       placeholder="Nome via"
                       :errors="getErrors('sede_legale_via')"></Field>
            </div>
            <div class="col-span-2 flex flex-col mb-3">
                <Field field_name="numero"
                       :required="!sede_legale_numero"
                       :model-value="sede_legale_numero"
                       :input-attrs="{disabled:disable_dati_azienda}"
                       @update:modelValue="$emit('update:sede_legale_numero', $event)"
                       :errors="getErrors('sede_legale_numero')" placeholder="00"></Field>
            </div>
        </div>

        <div class="flex flex-col mb-3">
            <Field :required="!sl.na_selection"
                   field_name="Sede legale nazione"
                   :errors="getErrors('sede_legale_nazione_id')">
                <VueMultiselect
                    :disabled="disable_dati_azienda"
                    v-model="sl.na_selection"
                    :options="sl.na_options"
                    placeholder="Nazione"
                    class="next-vue-multiselect-single"
                    track-by="id"
                    label="codice"
                    selectLabel=""
                    deselectLabel=""
                    selectedLabel=""
                    :internal-search="false"
                    @search-change="sl.na_search"
                >
                    <template v-slot:option="{option}">{{ option.codice }} - {{ option.nome }}</template>
                </VueMultiselect>
            </Field>
        </div>
        <div class="flex flex-col mb-3">
            <Field field_name="Sede legale cap"
                   :required="!sede_legale_cap"
                   :model-value="sede_legale_cap"
                   :input-attrs="{disabled:disable_dati_azienda}"
                   @update:modelValue="$emit('update:sede_legale_cap', $event)"
                   :errors="getErrors('sede_legale_cap')" placeholder="CAP"></Field>
        </div>

        <div v-show="sl.isNazioneItalia" class="col flex flex-col mb-3">
            <Field :errors="getErrors('sede_legale_provincia_id')"
                   :required="!sl.pa_selection"
                   field_name="Sede legale provincia">
                <VueMultiselect
                    :disabled="disable_dati_azienda"
                    v-model="sl.pa_selection"
                    :options="sl.pa_options"
                    @tag="(value)=>sl.pa_add({id:-1, nome:value})"
                    placeholder="Prov."
                    class="next-vue-multiselect-single"
                    track-by="id"
                    label="codice"
                    selectLabel=""
                    deselectLabel=""
                    selectedLabel=""
                    :internal-search="false"
                    @search-change="sl.pa_search"
                >
                </VueMultiselect>
            </Field>
        </div>
        <div v-show="sl.isNazioneItalia" class="flex flex-col mb-3">
            <Field :errors="getErrors('sede_legale_comune_id')"
                   :required="!sl.ca_selection"
                   field_name="Sede legale comune">
                <VueMultiselect
                    :disabled="disable_dati_azienda"
                    v-model="sl.ca_selection"
                    :options="sl.ca_options"
                    @tag="(value)=>sl.ca_add({id:-1, nome:value})"
                    placeholder="Comune"
                    class="next-vue-multiselect-single"
                    track-by="id"
                    label="nome"
                    selectLabel=""
                    deselectLabel=""
                    selectedLabel=""
                    :internal-search="false"
                    @search-change="sl.ca_search"
                >
                </VueMultiselect>
            </Field>
        </div>

        <div v-show="!sl.isNazioneItalia" class="flex flex-col mb-3">
            <Field field_name="Sede legale regione estera"
                   :required="!sede_legale_regione_estero"
                   :model-value="sede_legale_regione_estero"
                   @update:modelValue="$emit('update:sede_legale_regione_estero', $event)"
                   :input-attrs="{disabled:disable_dati_azienda}"
                   :errors="getErrors('sede_legale_regione_estero')" placeholder="Regione estera"></Field>
        </div>

        <div v-show="!sl.isNazioneItalia" class="flex flex-col mb-3">
            <Field field_name="Sede legale città estera"
                   :required="!sede_legale_citta_estero"
                   :model-value="sede_legale_citta_estero"
                   @update:modelValue="$emit('update:sede_legale_citta_estero', $event)"
                   :input-attrs="{disabled:disable_dati_azienda}"
                   :errors="getErrors('sede_legale_citta_estero')" placeholder="Città estera"></Field>
        </div>

        <div></div>
        <div class="grid grid-cols-8 gap-3 mb-3">

            <div class="col-span-5 flex flex-col">
                <Field field_name="Numero di dipendenti"
                       v-model="numero_dipendenti"
                       type="number"
                       :errors="getErrors('numero_dipendenti')" placeholder="Numero di dipendenti"></Field>
            </div>
            <div class="col-span-3 flex flex-col">
                <Field field_name="Dipendenti (Anno)"
                       v-model="dipendenti"
                       type="number"
                       :errors="getErrors('dipendenti')" placeholder="Anno"></Field>
            </div>
        </div>
        <div class="flex flex-col mb-3">
            <Field field_name="Ricavi"
                   v-model="ricavi"
                   :errors="getErrors('ricavi')" placeholder="Ricavi"></Field>
        </div>
        <div class="flex flex-col mb-3">
            <div class="font-bold pb-2">Data chiusura bilancio</div>
            <div class="flex gap-2">
                <input v-model="data_chiusura_bilancio" type="date"
                       class="p-2 bg-next-gray-md w-full">
            </div>

        </div>
    </div>

</template>
<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import MapViewer from "@/components/Address/MapViewer.vue";
import Field from "@/components/Field.vue";
import {Watch} from "vue-property-decorator/lib/decorators/Watch";
import Select from "@/components/Select.vue";
import Autocomplete from "@/setup/Autocomplete";
import aziendeManager from "@/api/Aziende";
import {ProvinciaComune} from "@/setup/ProvinciaComuneAutocomplete";


@Options({
    name: 'AnagraficaAzienda',
    components: {
        Field,
        MapViewer,
        Select
    },
    props: {
        ragione_sociale: {
            type: String,
            required: false
        },
        codice_fiscale: {
            type: String,
            required: false
        },
        azienda_id: {
            type: Number,
            required: false
        },
        sede_legale_nazione_id: {
            type: Number,
            required: false
        },
        sede_legale_provincia_id: {
            type: Number,
            required: false
        },
        sede_legale_comune_id: {
            type: Number,
            required: false
        },
        sede_legale_regione_estero: {
            type: String,
            required: false
        },
        sede_legale_citta_estero: {
            type: String,
            required: false
        },
        sede_legale_numero: {
            type: String,
            required: false
        },
        sede_legale_via: {
            type: String,
            required: false
        },
        sede_legale_cap: {
            type: String,
            required: false
        },
        place_id: {
            type: String,
            required: false
        },
        lat: {
            type: [String, Number],
            required: false
        },
        lng: {
            type: [String, Number],
            required: false
        },
        estera: {
            type: Boolean,
            required: false,
            default: false
        },
        tipo: {
            type: Number,
            required: false,
            default: 0
        },
        partita_iva: {
            type: String,
            required: false
        },
        errors: {
            type: Object,
            required: false,
            default: () => ({})
        },
        disable_dati_azienda: {
            type: Boolean,
            required: false,
            default: false
        },
        disable_autocomplete_azienda: {
            type: Boolean,
            required: false,
            default: false
        },
        numero_dipendenti: {
            type: Number,
            required: false
        },
        dipendenti: {
            type: Number,
            required: false
        },
        ricavi: {
            type: Number,
            required: false
        },
        data_chiusura_bilancio: {
            type: String,
            required: false
        }
    }


})
export default class AnagraficaAzienda extends Vue {
    errors!: any
    estera!: boolean
    tipo!: number
    disable_autocomplete_azienda!: boolean

    aziendaAutocomplete: any = setup(() => Autocomplete(aziendeManager))
    sl = setup(() => {
        return ProvinciaComune()
    })

    tipo_options = [
        {id: 0, text: 'Privato'},
        {id: 1, text: 'Pubblico'},
    ]
    tipo_model: any = null

    @Watch('tipo')
    tipoWatch(new_value: any, old: any) {
        this.tipo_model = this.tipo_options.find((el: any) => {
            return new_value == el.id
        })
    }

    @Watch('azienda_id')
    aziendaIdWatch(azienda_id: any, old: any) {
        this.aziendaAutocomplete.retrieve(azienda_id).then((res: any) => {
            res = res.data
            if (azienda_id > 0) {
                this.$emit('update:estera', res.estera)
                this.$emit('update:tipo', res.tipo)

                this.$emit('update:place_id', res.a_place_id)
                this.$emit('update:lat', res.a_lat)
                this.$emit('update:lng', res.a_lng)

                this.$emit('update:partita_iva', res.partita_iva)
                this.$emit('update:codice_fiscale', res.codice_fiscale)
                this.$emit('update:ragione_sociale', res.ragione_sociale)

                this.$emit('update:sede_legale_via', res.sede_legale_via)
                this.$emit('update:sede_legale_numero', res.sede_legale_numero)
                this.$emit('update:sede_legale_cap', res.sede_legale_cap)
                this.$emit('update:sede_legale_regione_estero', res.sede_legale_regione_estero)
                this.$emit('update:sede_legale_citta_estero', res.sede_legale_citta_estero)

                this.$emit('update:sede_legale_comune_id', res.sede_legale_comune_id)
                this.$emit('update:sede_legale_nazione_id', res.sede_legale_nazione_id)
                this.$emit('update:sede_legale_provincia_id', res.sede_legale_provincia_id)

                this.$emit('update:numero_dipendenti', res.numero_dipendenti)
                this.$emit('update:dipendenti', res.dipendenti)
                this.$emit('update:ricavi', res.ricavi)
                this.$emit('update:data_chiusura_bilancio', res.data_chiusura_bilancio)
            }
        })

    }

    @Watch('sede_legale_nazione_id')
    sedeLegaleNazioneIdWatch(sede_legale_nazione_id: any, old: any) {
        this.sl.na_retrieve(sede_legale_nazione_id)
    }

    @Watch('sede_legale_provincia_id')
    sedeLegaleProvinciaIdWatch(sede_legale_provincia_id: any, old: any) {
        this.sl.pa_retrieve(sede_legale_provincia_id)
    }

    @Watch('sede_legale_comune_id')
    sedeLegaleComuneIdWatch(sede_legale_comune_id: any, old: any) {
        this.sl.ca_retrieve(sede_legale_comune_id)
    }

    @Watch('tipo_model')
    tipoModelWatch(new_value: any, old: any) {
        this.$emit('update:tipo', new_value?.id)
    }

    @Watch('partita_iva')
    pivaWatch(new_value: any, old: any) {
        console.log(new_value)
    }

    @Watch('aziendaAutocomplete.selection')
    pivaSelectionWatch(new_value: any, old: any) {
        if (new_value) {
            if (new_value.id < 0) {
                this.$emit('update:partita_iva', new_value.partita_iva)
                this.$emit('update:azienda_id', new_value.id)
            } else {
                this.$emit('update:partita_iva', new_value.partita_iva)
                this.$emit('update:azienda_id', new_value.id)
            }
        } else {
            this.$emit('update:partita_iva', null)
            this.$emit('update:azienda_id', null)
        }
    }

    onAddressInformationChange(address: any) {
        this.sl.disableProvinciaWatcher = true
        this.sl.na_search(address.country).then(() => {
            this.sl.na_selection = this.sl.na_options.find((e: any) => e.nome.toLowerCase() == address?.country?.toLowerCase())
            return this.sl.pa_search(address?.province)
        }).then(() => {
            this.sl.pa_selection = this.sl.pa_options.find((e: any) => e.codice.toLowerCase() == address?.province?.toLowerCase())
            return this.sl.ca_search(address?.locality)
        }).then(() => {
            this.sl.ca_selection = this.sl.ca_options.find((e: any) => e.nome.toLowerCase() == address?.locality?.toLowerCase())
        }).finally(() => {
            this.sl.disableProvinciaWatcher = false
        })


        this.$emit('update:sede_legale_via', address.route)
        this.$emit('update:sede_legale_numero', address.street_number)
        this.$emit('update:sede_legale_cap', address.postal_code)
        this.$emit('update:sede_legale_regione_estero', address.region)
        this.$emit('update:sede_legale_citta_estero', address.locality)
    }

    @Watch('sl.pa_selection')
    sede_legale_provincia(new_value: any, old: any) {
        this.$emit('update:sede_legale_provincia_id', new_value?.id || new_value)
    }

    @Watch('sl.na_selection')
    sede_legale_nazione(new_value: any, old: any) {
        this.$emit('update:sede_legale_nazione_id', new_value?.id || new_value)
    }

    @Watch('sl.ca_selection')
    sede_legale_comune(new_value: any, old: any) {
        this.$emit('update:sede_legale_comune_id', new_value?.id || new_value)
    }

    @Watch('numero_dipendenti')
    numeroDipendentiWatch(new_value: any, old: any) {
        this.$emit('update:numero_dipendenti', new_value)
    }

    @Watch('dipendenti')
    dipendentiWatch(new_value: any, old: any) {
        this.$emit('update:dipendenti', new_value)
    }

    @Watch('ricavi')
    ricaviWatch(new_value: any, old: any) {
        this.$emit('update:ricavi', new_value)
    }

    @Watch('data_chiusura_bilancio')
    dataChiusuraBilancioWatch(new_value: any, old: any) {
        this.$emit('update:data_chiusura_bilancio', new_value)
    }

    anagraficheAutocompleteSarch($event: any, timeout = 500) {
        this.aziendaAutocomplete.search($event, timeout).then(() => {
            this.aziendaAutocomplete.options.map((e: any) => {
                e['$isDisabled'] = this.disable_autocomplete_azienda
            })
        })
    }

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

}
</script>


<style lang="scss">

</style>
